<template>
  <div>
    <div class="header  layui-bg-green" style="display: flex; justify-content: space-between; align-items: center;">
      <div class="layui-nav  layui-bg-green">
        <a class="layui-nav-item layui-this " style="cursor: pointer;color:white;margin-left:20px;" href="/">首页</a>
      </div>
      <a style="color:white;" :href="qqgroupLink" target="_blank" >
        <div style="margin-right:20px;"><i class="layui-icon layui-icon-login-qq"></i>
          <span>QQ群号：{{qqgroupNumber}}</span><span class="layui-badge-dot"></span>
        </div>
      </a>
    </div>
    <div class="cha_info">
      <fieldset class="layui-elem-field layui-field-title" style="margin-top: 30px;">
        <legend>【查询系统使用说明】</legend>
      </fieldset>

      <div class="info">
        1.查询系统能查到的必然会出，查不到的就不一定会出,出处可能是NPC合成等方式，若不能确定，请联系测试群管。<br>
        2.若发现某些物品是确实需要的，但是在物品列表中差不到或者与游戏当中的名字不符，请联系测试群管。<br>
        3.只支持现代浏览器（如360极速浏览器、谷歌、搜狗等），IE、IE内核等老古董不支持。<br>
        4.实在查询不到，请联系测试群管。
      </div>

      <fieldset class="layui-elem-field layui-field-title" style="margin-top: 30px;">
        <legend>【查询系统游戏选择】</legend>
      </fieldset>

      <div class="version_list">
        <ul>
          <li v-for="(item,index) in apiData" :key="index">
            <router-link :to="{ name: 'detail', query: { c_id: item.c_id } }">
              <button type="button" class="layui-btn layui-btn-radius">{{ item.c_name }}</button>
            </router-link>
          </li>
        </ul>
      </div>
    </div>

    <!-- 固定底部备案信息 -->
    <footer class="fixed-footer">
      <div class="footer-content" ref="footerRef">
        <span v-if="qqgroupLink">
          <a :href="qqgroupLink" target="_blank">
            <span style="color:#666;">欢迎加入</span>
            <span style="color:#666;"><i class="layui-icon layui-icon-login-qq"></i>
              QQ群{{qqgroupNumber}}</span>&nbsp;
            <i class="layui-icon layui-icon-login-qq"></i>交流游戏
          </a>
        </span>
      </div>


      <!-- 滚动广告区域 -->
      <div class="advertising-scroll" v-if="adv && adv.length > 0">
        <div class="scroll-container">
          <transition-group name="scroll" tag="div" class="scroll-wrapper">
            <div
                v-for="item in [currentAdv]"
                :key="item.id"
                class="scroll-item"
            >
              <a :href="item.adv_link" target="_blank" class="adv-link">
                {{ item.title }}
              </a>
            </div>
          </transition-group>
        </div>
      </div>
    </footer>
  </div>
</template>


<script>
import { gamelist } from '@/utils/JSONHelper';
export default {
  name: 'ListPage',
  data() {
    return {
      apiData: [],
      loading: true,
      errorMessage: null,
      miitbianInfo: '',
      statistics: '',
      qqgroupLink: '',
      qqgroupNumber: '',
      adv: [],
      currentAdvIndex: 0,
      scrollTimer: null,
    };
  },
  computed: {
    currentAdv() {
      if (this.adv && this.adv.length > 0) {
        return this.adv[this.currentAdvIndex];
      }
      return null;
    }
  },
  async mounted() {
    await this.loadData();
    await this.getAdv();
    this.startScroll();
  },
  beforeUnmount() {
    this.stopScroll();
  },
  async created() {
    await this.getConfigData(); // 先请求拿数据
    // nextTick放到请求完成后，DOM渲染完再插脚本
    this.$nextTick(() => {
      if (this.statistics) {
        this.insertStatisticsScript();
      }
    });
  },
  methods: {
    async loadData() {
      try {
        this.loading = true;
        const result = await gamelist('droprate/api.dropratelist');
        if (result.code === 1) {
          this.apiData = result.data;
        } else {
          this.errorMessage = result.info || '请求失败';
        }
      } catch (error) {
        this.errorMessage = '网络请求异常: ' + error.message;
      } finally {
        this.loading = false;
      }
    },
    async getAdv(){
      try{
        this.loading = true;
        const rs = await gamelist('adv/api.advapi');
        if(rs.code === 1){
          this.adv = rs.data;
        }else{
          this.errorMessage = rs.info || '请求失败';
        }
      }catch(error){
        this.errorMessage = '网络请求异常: ' + error.message;
      }finally{
        this.loading = false;
      }
    },
    startScroll() {
      if (this.adv && this.adv.length > 1) {
        this.scrollTimer = setInterval(() => {
          this.currentAdvIndex = (this.currentAdvIndex + 1) % this.adv.length;
        }, 2000);
      }
    },
    stopScroll() {
      if (this.scrollTimer) {
        clearInterval(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    // 动态插入统计脚本的方法
    insertStatisticsScript() {
      if (!this.statistics.trim()) return
      // 全局标记防止重复创建统计脚本（路由多次刷新重复执行）
      if (window._STAT_BAIDU_LOADED) return
      window._STAT_BAIDU_LOADED = true
    
      // 创建内嵌JS的script标签
      const script = document.createElement('script')
      script.textContent = this.statistics // 填入后端原生JS代码，不要改任何字符
      script.id = 'dynamic-statistics-script'
    
      // 优先插入底部footer，找不到就插body末尾
      if (this.$refs.footerRef) {
        this.$refs.footerRef.appendChild(script)
      } else {
        document.body.appendChild(script)
      }
    },
    async getConfigData(){
      const result = await gamelist('admin/api.config/getconfig');
      if (result.code === 1) {
        this.miitbianInfo = result.data['miitbeian'] || '';
        this.statistics = result.data['statistics'] || '';
        this.qqgroupLink = result.data['qqgroup'] || '';
        //提取QQ加群链接中的群号
        if (this.qqgroupLink) {
          const urlParams = new URLSearchParams(this.qqgroupLink);
          this.qqgroupNumber = urlParams.get('group_code') || '';
          // 如果URLSearchParams方法不工作，使用正则表达式作为备选方案
          if (!this.qqgroupNumber) {
            const match = this.qqgroupLink.match(/[?&]group_code=(\d+)/);
            if (match && match[1]) {
              this.qqgroupNumber = match[1];
            }
          }
        }//结束


      } else {
        this.errorMessage = result.info || '请求失败';
      }
    },
  }
};
</script>



<style>
.footer-content  a:hover{
  color: #777 !important;
}
.footer-content  a{
  color: #666;
}
.layui-badge-dot {
  display: block;
  float: right;
  margin-top: 8px;
  margin-left:4px;
}
.cha_info{
  margin: 0 auto; max-width: 55%;height:88%;
}
.version_list ul li {
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 10px;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.header {
  margin: 0 auto;
}
.nav-link {
  color: white;
  text-decoration: none;
}
/* 固定底部样式 */
.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
}

.footer-content {
  font-size: 12px;
  text-align: center;
}
/* 滚动广告样式 */
.advertising-scroll {
  height: 25px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.scroll-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.scroll-content {
  transition: transform 0.5s ease-in-out;
  will-change: transform;
}

.scroll-item {
  height: 25px;
  line-height: 25px;
  text-align: center;
  font-size: 12px;
}

.adv-link {
  color: #fff;
  text-decoration: none;
  transition: color 0.3s;
  padding-left:10px;
  padding-right:10px;
  background: #1890ff;
  border-radius: 2px;
}

.adv-link:hover {
  color: #ff3300;
  text-decoration: underline;
}


@media (max-width: 768px) {
  .cha_info{
    margin: 0 auto; max-width: 90%;height:88%;
  }
}
</style>
